import React from 'react';
import classnames from 'classnames';

import NormalButton from './NormalButton';

import './HoverAccentButton.css';

const HoverAccentButton = props => (
  <span className="hoveraccent-button">
    <NormalButton
      {...props}
      textColorClassName={classnames('theme--color-primary', {
        'theme--color-accent-hover': !props.disabled
      })}
    />
  </span>
);

HoverAccentButton.propTypes = NormalButton.propTypes;

module.exports = HoverAccentButton;
